import { Observable } from "rxjs";
import { get } from "../../../service/api";
import { ILoginResponseDto } from "../interface/dto/login-response.dto";

export const login = (code: string): Observable<ILoginResponseDto> =>
    get<ILoginResponseDto>("/auth/login", { code });
